<template>
  <SACModal
    modalClass="c-action-modal"
    :cardClass="`ccm-${actionModalView}`"
    :show="showActionModal"
    :close="() => toggleActionModalCustomer(false)"
  >
    <template
      v-if="actionModalView === 'invite-manual-member'"
      #content
    >
      <InviteMember />
    </template>
    <template
      v-else-if="actionModalView === 'invite-csv-member'"
      #content
    >
      <InviteCsvMember />
    </template>
    <template
      v-else-if="actionModalView === 'create-cust'"
      #content
    >
      <ReviewCsvMember />
    </template>
    <template
      v-else-if="actionModalView === 'invite-member'"
      #content
    >
      <ChooseMethod :toggleActionModal="toggleActionModalCustomer"/>
    </template>
    <template
      v-else-if="actionModalView === 'sms-text-preview'"
      #content
    >
      <SMSTextPreview :close="() => toggleActionModalCustomer(true, 'invite-manual-member')"/>
    </template>
    <template
      v-else-if="actionModalView === 'text-warning'"
      #content
    >
      <TextWarning :toggleActionModal="toggleActionModalCustomer"/>
    </template>
  </SACModal>
</template>

<script>
import { mapState } from 'vuex';

import customerMixin from '@shared/mixins/customerMixin';

import SACModal from '@shared/components/sac/SACModal.vue';
import InviteMember from './modal/InviteMember.vue';
import InviteCsvMember from './modal/InviteCsvMember.vue';
import ReviewCsvMember from './modal/ReviewCsvMember.vue';
import ChooseMethod from './modal/ChooseMethod.vue';
import SMSTextPreview from './modal/SMSTextPreview.vue';
import TextWarning from './modal/TextWarning.vue';

export default {
  name: 'ActionModal',
  components: {
    SACModal,
    InviteMember,
    InviteCsvMember,
    ReviewCsvMember,
    ChooseMethod,
    SMSTextPreview,
    TextWarning,
  },
  mixins: [customerMixin],
  computed: {
    ...mapState({
      actionModalView: (state) => state.customer.actionModalView,
      showActionModal: (state) => state.customer.showActionModal,
    }),
  },
  methods: {
    closeModal() {
      this.$store.dispatch('changeCustomerValue', {
        field: 'showActionModal',
        value: false,
      });
    },
  },
};
</script>

  <style lang="scss">

  .c-action-modal {
    .ccm-invite-member {
      width: 500px;
      max-height: calc(100vh - 70px);
      .ac-body-container {
        overflow-y: auto;
      }
    }
    .ccm-invite-manual-member {
      width: 770px;
      height: 740px;
      max-height: calc(100vh - 70px);
      .ac-body-container {
        overflow-y: auto;
      }
    }
    .ccm-invite-csv-member {
      width: 650px;
      max-height: calc(100vh - 70px);
      .ac-body-container {
        overflow-y: auto;
      }
    }
    .ccm-create-cust {
      width: 1250px;
      .ac-body-container {
        max-height: calc(100vh - 70px);
        overflow-y: auto;
        .scroll-view {
          max-height: 20vh;
          overflow-y: auto;
        }
      }
    }
    .ccm-sms-text-preview {
      width: 600px;
      .ac-body-container {
        max-height: calc(100vh - 250px);
        overflow-y: auto;
      }
    }
    .ccm-text-warning {
      width: 600px;
      .ac-body-container {
        text-align: center;
      }
    }
    .ac-card-content {
      display: flex;
      flex-direction: column;
      height: 100%;
      animation: fadeIn 0.5s ease;
      position: relative;
      .ac-header-container {
        padding: 29px 24px 19px 24px;
        display: flex;
        align-items: center;
        border-bottom: 1px solid $NBLUE10;
        .ac-header {
          font-size: 1.25rem;
          font-weight: 500;
        }
        .ac-close-button {
          width: 32px;
          height: 32px;
          border-radius: 6px;
          background-color: $NBLUE10;
          display: flex;
          align-items: center;
          justify-content: center;
          &:hover {
            background-color: $NBLUE20;
          }
          .ac-close {
            width: 10px;
            height: 10px;
          }
        }
      }
      .ac-body-container {
        flex: 1;
        padding: 20px;
        display: flex;
        flex-direction: column;
      }
    }
    .ac-footer-container {
      display: flex;
      align-items: center;
      justify-content: flex-end !important;
      padding: 16px 12px;
      border-top: 1px solid $NBLUE10;
      button:not(:last-child) {
        margin-right: 12px;
      }
      .ac-form-button {
        padding: 0 16px;
        height: 40px;
        border-radius: 6px;
        background-color: $NBLUE100;
        color: $WHITE;
        font-weight: 600;
        &:hover {
          background-color: $NBLUE90;
        }
        &.redbg {
          background-color: $TOMATO100 !important;
          color: $WHITE !important;
        }
      }
    }
    .ac-overlay {
      border-radius: 12px;
    }
    .dropbox-container {
      border: 3px dashed $BLACK;
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      border-radius: 8px;
      gap: 16px;
      padding: 48px;
      position: relative;
      &:hover {
        opacity: 0.5;
      }

      .spreadsheet {
        height: 96px;
        width: 77px;
      }

      .db-input {
        opacity: 0;
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        cursor: pointer;
      }
    }
    .f-button {
      color: $CONTENTGRAY;
      text-decoration: underline;
      margin: 16px 0 0;
      &:hover {
        color: $NBLUE100;
      }
    }
  }
</style>
